const scene = "group/";

export const UPDATE_GROUP = `${scene}UPDATE_GROUP`;
export const UPDATE_FILTER = `${scene}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${scene}UPDATE_REDUCER`;
